import React from "react";
import styled from "styled-components";
import { projectData } from "../data";
import { Button } from "./reusable_components";

const ProjectBox = styled.div`
  width: 100%;
  height: auto;
  padding: 10px;
  margin: 30px auto 180px auto;
  display: flex;

  @media screen and (max-width: 770px) {
    flex-direction: column-reverse;
  }
`;
const Col = styled.div`
  flex: 1;
  margin-bottom: 20px;
  height: 400px;
`;
const GlassSpan = styled.div`
  height: 140px;
  /* padding: 20px; */
  color: #fff;
  border-radius: 10px;
  position: relative;
  @media screen and (max-width: 770px) {
    height: 330px;
  }
`;
const GlassMorphism = styled.span`
  /* From https://css.glass */
  width: 95%;
  height: auto;
  display: inline-block;
  padding: 10px;
  top: -30%;
  position: absolute;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  @media screen and (max-width: 770px) {
    top: 0%;
  }
`;
const Project = () => {
  return (
    <>
      {projectData.map((data, index) => (
        <ProjectItem data={data} key={index} />
      ))}
    </>
  );
};

const ProjectItem = ({ data }) => {
  return (
    <>
      <ProjectBox>
        <Col>
          <p style={{ color: "#693b93" }}>Project Feature</p>
          <h1 style={{ color: "#fff" }}>{data.name}</h1>
          <GlassSpan>
            <GlassMorphism>{data.desc}</GlassMorphism>
          </GlassSpan>
          <Button value={"visit"} link={data.link} rel="noreferrer" />
        </Col>
        <Col style={{ border: "1px solid #693b93" }}>
          <iframe
            src={data.link}
            frameBorder="0"
            width={"100%"}
            height={400}
            scrolling="no"
            title={data.name}
          ></iframe>
        </Col>
      </ProjectBox>
    </>
  );
};

export default Project;
